import { canViewLudumFeature } from '@/util/featureHelper';
import { LUDUM_SUBSCRIPTION_FEATURES } from '@/constants';

export const clubPermissions = {
    namespaced: true,

    getters: {
        canViewFeatureAdditionalReports() {
            return canViewLudumFeature(LUDUM_SUBSCRIPTION_FEATURES.ADDITIONAL_REPORTS);
        },

        canViewFeatureDrv() {
            return canViewLudumFeature(LUDUM_SUBSCRIPTION_FEATURES.DRV);
        },

        canViewFeatureGmt() {
            return canViewLudumFeature(LUDUM_SUBSCRIPTION_FEATURES.GMT);
        },

        canViewFeatureGpsHr() {
            return canViewLudumFeature(LUDUM_SUBSCRIPTION_FEATURES.GPS_HR);
        },

        canViewFeatureImports() {
            return canViewLudumFeature(LUDUM_SUBSCRIPTION_FEATURES.IMPORTS);
        },

        canViewFeatureMorningMonitoring() {
            return canViewLudumFeature(LUDUM_SUBSCRIPTION_FEATURES.MORNING_MONITORING);
        },

        canViewFeatureNonCompetitive() {
            return canViewLudumFeature(LUDUM_SUBSCRIPTION_FEATURES.NON_COMPETITIVE);
        },

        canViewFeatureRpe() {
            return canViewLudumFeature(LUDUM_SUBSCRIPTION_FEATURES.RPE);
        },

        canViewFeatureTrainingScore() {
            return canViewLudumFeature(LUDUM_SUBSCRIPTION_FEATURES.TRAINING_SCORE);
        },

        canViewFeatureWeeklySummary() {
            return canViewLudumFeature(LUDUM_SUBSCRIPTION_FEATURES.WEEKLY_SUMMARY);
        },

        canViewFeatureRacingReport() {
            return canViewLudumFeature(LUDUM_SUBSCRIPTION_FEATURES.RACING_REPORT);
        },

        canViewFeatureLiveResults() {
            return canViewLudumFeature(LUDUM_SUBSCRIPTION_FEATURES.LIVE_RESULTS);
        },

        canViewFeaturePerformanceReport() {
            return canViewLudumFeature(LUDUM_SUBSCRIPTION_FEATURES.PERFORMANCE_REPORT);
        },

        canViewFeatureImprovementReport() {
            return canViewLudumFeature(LUDUM_SUBSCRIPTION_FEATURES.IMPROVEMENT_REPORT);
        },

        canViewFeatureAnalysisReport() {
            return canViewLudumFeature(LUDUM_SUBSCRIPTION_FEATURES.ANALYSIS_REPORT);
        },

        canViewFeatureComparisonReport() {
            return canViewLudumFeature(LUDUM_SUBSCRIPTION_FEATURES.COMPARISON_REPORT);
        },

        canManageLiveResultsControls() {
            return canViewLudumFeature(LUDUM_SUBSCRIPTION_FEATURES.LIVE_RESULTS_CONTROLS);
        },

        canViewFeaturePaddlingGmt() {
            return canViewLudumFeature(LUDUM_SUBSCRIPTION_FEATURES.PADDLING_GMT);
        },

        canViewFeatureStrokeRateIntensities() {
            return canViewLudumFeature(LUDUM_SUBSCRIPTION_FEATURES.STROKE_RATE_INTENSITIES);
        },

        canViewFeatureConnectEquipment() {
            return canViewLudumFeature(LUDUM_SUBSCRIPTION_FEATURES.CONNECT_EQUIPMENT);
        },

        canViewFeatureCrewQRCodes() {
            return canViewLudumFeature(LUDUM_SUBSCRIPTION_FEATURES.CREW_QR_CODES);
        },

        canViewFeatureTelemetry() {
            return canViewLudumFeature(LUDUM_SUBSCRIPTION_FEATURES.TELEMETRY);
        },
    }
};

export default clubPermissions;
